import React from 'react'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import Generator from './components/Generator/Generator'

function App() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />

      <Generator />

      <Footer />
    </div>
  );
}

export default App;
